<template>
  <div @click="$emit('click', $event)" ref="box" class="box" :style="styles">
    <slot />
    <template v-if="canResize">
      <div
        @click.prevent.stop
        @mousedown.prevent.stop="onMouseDownGrip($event, 'x')"
        @mouseup.stop.prevent="onMouseDownFromGrip"
        class="warehouse-view-table-box-grip warehouse-view-table-box-grip-right"
      ></div>
      <div
        @mousedown.prevent="onMouseDownGrip($event, 'y')"
        @mouseup.prevent.stop="onMouseDownFromGrip"
        @click.prevent
        class="warehouse-view-table-box-grip warehouse-view-table-box-grip-bottom"
      ></div>
    </template>
  </div>
</template>

<script>
import { setUnitSize } from "@/utils/pureFunctions.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

const DEFAULT_BOX_HANDLER_DATA = {
  grip: null,
  rtl: null,
  startPosition: null,
};

let boxHandlerData = {
  ...DEFAULT_BOX_HANDLER_DATA,
};

export default {
  name: "WarehouseBox",
  props: {
    width: {
      type: [Number, String],
      default: DEFAULT_STILLAGE_BOX_SIZE,
    },
    height: {
      type: [Number, String],
      default: DEFAULT_STILLAGE_BOX_SIZE,
    },
    canResize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      return {
        width: setUnitSize(this.width),
        minWidth: setUnitSize(this.width),
        height: setUnitSize(this.height),
      };
    },
  },
  methods: {
    onMouseDownGrip(e, rtl) {
      e.preventDefault();
      e.stopPropagation();
      boxHandlerData.grip = document.createElement("span");
      boxHandlerData.grip.style.background = "var(--primary)";
      boxHandlerData.grip.style.position = "absolute";
      boxHandlerData.rtl = rtl;
      if (rtl === "x") {
        boxHandlerData.grip.style.width = "2px";
        boxHandlerData.grip.style.height = "60px";
        boxHandlerData.startPosition = e.pageX;
        boxHandlerData.grip.style.top = e.pageY - 30 + "px";
        boxHandlerData.grip.style.left = e.pageX + "px";
      } else {
        boxHandlerData.grip.style.width = "60px";
        boxHandlerData.grip.style.height = "2px";
        boxHandlerData.grip.style.top = e.pageY + "px";
        boxHandlerData.grip.style.left = e.pageX - 30 + "px";
        boxHandlerData.startPosition = e.pageY;
      }
      document.body.append(boxHandlerData.grip);
      document.addEventListener("mouseup", this.onMouseDownFromGrip);
      document.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseDownFromGrip(e) {
      e.preventDefault();
      e.stopPropagation();
      if (boxHandlerData.grip) {
        const { box } = this.$refs;
        if (boxHandlerData.rtl === "x") {
          const width =
            box.clientWidth + (e.pageX - boxHandlerData.startPosition);
          this.$emit(
            "changeWidth",
            width < DEFAULT_STILLAGE_BOX_SIZE
              ? DEFAULT_STILLAGE_BOX_SIZE
              : width
          );
        } else {
          const height =
            box.clientHeight + (e.pageY - boxHandlerData.startPosition);
          this.$emit(
            "changeHeight",
            height < DEFAULT_STILLAGE_BOX_SIZE
              ? DEFAULT_STILLAGE_BOX_SIZE
              : height
          );
        }
        boxHandlerData.grip.remove();
        boxHandlerData.grip = null;
      }
      this.unbindEvents();
      boxHandlerData = { ...DEFAULT_BOX_HANDLER_DATA };
    },
    unbindEvents() {
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseDownFromGrip);
    },
    onMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      if (boxHandlerData.rtl === "x") {
        boxHandlerData.grip.style.left = e.pageX + "px";
      } else {
        boxHandlerData.grip.style.top = e.pageY + "px";
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  border-radius: 5px;
}
</style>
